import { useMemo } from 'react';
import { EntityName } from 'shared/domain/entityName';
import { projectClient } from 'shared/domain/project/projectClient';
import { useEntityById } from 'store/entityCollection';
import { useProjects } from 'store/projects';
import { modelToSingleView, ProjectOnSingleView } from './projectOnSingleView';

/** A project for its details view, archived ones included; kept current after its changes. */
export function useProjectOnSingleView(projectId: string | undefined): {
  project: ProjectOnSingleView | undefined;
  loading: boolean;
} {
  const { items: projects } = useProjects();
  const { item: projectModel, loading } = useEntityById({
    id: projectId,
    client: projectClient,
    items: projects,
    entityName: EntityName.projects,
  });

  return useMemo(
    () => ({ project: projectModel && modelToSingleView(projectModel), loading }),
    [projectModel, loading]
  );
}
